export enum EmailTagsEnum {
	GAME_URL = 'game url',
	LEGALS_URL = 'legals url',
	START_DATE = 'start date',
	END_DATE = 'end date',
	PAYMENT_DATE = 'payment date',
	PAYMENT_LIMIT = 'payment limit',
	EXPIRATION_LIMIT = 'expiration limit',
	REWARD_CODE = 'dotation code',
	GAIN = 'gain',
	REWARD_MODALITY = 'dotation modality',
	REWARD_TEMPLATE = 'dotation template',
	CART_AMOUNT = 'cart amount',
	CART_DATE = 'cart date',
	CART_NUMBER = 'cart number',
	BANK_INFORMATIONS_URL = 'bank informations url',
	MAIN_PROBA_FRACTION = 'main proba fraction',
	EXPERIENCE_EXPIRATION = 'experience expiration',
	GAME_EXPIRATION = 'ticket expiration',
	SITE_NAME = 'site name',
	GIFT = 'gift',
}
